export default __webpack_public_path__ + "b82116ada3a6b5210a1e4e20b9a061ec.webp";